export function getDictMap (dictList) {
  const dictMap = {}
  dictList.forEach(item => {
    dictMap[item.value] = item.label
  })
  return dictMap
}

export const UNLIMIT_VALUE = '-999$&*^#'

export function getDictList (dictList, hasUnlimit, unlimitOption, isKeyNumber) {
  const list = []
  if (hasUnlimit) {
    if (unlimitOption) {
      list.push(unlimitOption)
    } else {
      list.push({
        value: UNLIMIT_VALUE,
        label: '全部'
      })
    }
  }

  dictList.forEach(item => {
    list.push({
      value: isKeyNumber ? Number(item.value) : item.value,
      label: item.label
    })
  })

  return list
}

export function getDictLabel (dictList, value) {
  const index = dictList.findIndex(item => item.value == value)
  if (index > -1) {
    return dictList[index].label
  } else {
    return ''
  }
}

export function getDictValue (dictList, label) {
  const index = dictList.findIndex(item => item.label == label)
  if (index > -1) {
    return dictList[index].value
  } else {
    return ''
  }
}

export const DICT_ORDER_STATUS = [
  {
    value: '40',
    label: '待审核'
  },
  {
    value: '42',
    label: '取款审核'
  },
  {
    value: '60',
    label: '还款中'
  },
  {
    value: '-2',
    label: '认证中'
  },
  {
    value: '-1',
    label: '待营业员选择套餐'
  },
  {
    value: '5',
    label: '待用户确认'
  },
  {
    value: '0',
    label: '待选择套餐'
  },
  {
    value: '10',
    label: '待营业员确认'
  },
  // {
  //     value: '30',
  //     label: '已签约'
  // },
  // {
  //     value: '35',
  //     label: '补充材料'
  // },
  {
    value: '37',
    label: '驳回补充'
  },
  {
    value: '20',
    label: '待签约'
  },
  {
    value: '45',
    label: '待支付首付款'
  },
  {
    value: '46',
    label: '待锁机'
  },
  {
    value: '50',
    label: '待放款'
  },
  {
    value: '70',
    label: '已结清'
  },
  {
    value: '80',
    label: '待退款'
  },
  {
    value: '90',
    label: '审核拒绝'
  },
  {
    value: '91',
    label: '退款成功'
  },
  {
    value: '92',
    label: '退款失败'
  },
  {
    value: '95',
    label: '关闭'
  }
]

export const DICT_INVESTOR_TYPE = [
  { value: '0', label: '自有资金' },
  { value: '1', label: '西湖小贷' },
  { value: '2', label: '紫乌租' },
  { value: '3', label: '和喜租物' },
  { value: '4', label: '上海匠恩' }
]

export const DICT_OVERDUE_STATUS = [
  { value: '2', label: '未逾期' },
  { value: '3', label: '已逾期' }
]

export const DICT_COLLECTION_TAG = [
  { value: '1', label: '办单套现' },
  { value: '2', label: '异地办单' },
  { value: '3', label: '用户诈骗' },
  { value: '4', label: '关机' },
  { value: '5', label: '停机' },
  { value: '6', label: '空号' },
  { value: '7', label: '拒接' },
  { value: '8', label: '其他' },
  { value: '9', label: '未填写' },
  { value: '10', label: '已安排起诉' },
  { value: '11', label: '发律师函' },
  { value: '12', label: '发司法信息' }
]

export const DICT_COLLECTION_TAG_SELECT = [
  { value: '8', label: '其他' },
  { value: '10', label: '已安排起诉' },
  { value: '11', label: '发律师函' },
  { value: '12', label: '发司法信息' }
]

export const DICT_USER_TYPE = [
  { value: '1', label: '用户' },
  { value: '2', label: '超级操盘手' },
  { value: '3', label: '普通操盘手' },
  { value: '5', label: '商户' },
  { value: '6', label: '营业员' }
]

export const DICT_SHOP_OPERATE_NAME = [
  { value: '1', label: '办单权限' },
  { value: '2', label: '办单地理限制' },
  { value: '4', label: '测算权限' },
  { value: '5', label: '添加备注' }
]

export const DICT_SHOP_PERMISSION_SWITCH = [
  { value: '1', label: '开启' },
  { value: '2', label: '关闭' }
]

export const DICT_SHOP_PERMISSION_CLOSE_REASON = [
  { value: '1', label: '办单套现' },
  { value: '2', label: '违规操作' },
  { value: '3', label: '其他操作' }
]

export const DICT_PHONE_CALL_TYPE = [
  { value: '1', label: '打入' },
  { value: '2', label: '拨出' },
  { value: '3', label: '未接' },
  { value: '4', label: '语音邮件通话' },
  { value: '5', label: '被拒接' },
  { value: '6', label: '自动阻止的呼叫' },
  { value: '7', label: '在另一台设备上接听' }
]

export const DICT_BILL_PROVE_PLATFORM = [
  { value: 'alipay', label: '支付宝' },
  { value: 'wechat', label: '微信' }
]

export const DICT_BILL_PROVE_INOUT = [
  { value: '收入', label: '收入' },
  { value: '支出', label: '支出' },
  { value: '其他', label: '其他' },
  { value: '不计收支', label: '不计收支' }
]

export const DICT_BLACK_ELEMENT_TYPE = [
  { value: '1', label: '手机号' },
  { value: '2', label: '身份证号' },
  { value: '3', label: 'deviceId' },
  { value: '4', label: 'ip' },
  { value: '5', label: '统一社会代码' },
  { value: '6', label: 'GPS' }
]

export const DICT_TEL_ONLINE_TIME = [
  { value: '1', label: '0-3' },
  { value: '2', label: '3-6' },
  { value: '3', label: '6-12' },
  { value: '4', label: '12-24' },
  { value: '5', label: '>24' }
]

export const DICT_PHONE_BOOK_STATUS = [
  { value: '-1', label: '未处理' },
  { value: '0', label: '正在识别' },
  { value: '1', label: '待接听铃声' },
  { value: '2', label: '正常' },
  { value: '4', label: '空号' },
  { value: '5', label: '停机' },
  { value: '6', label: '暂停服务' },
  { value: '10', label: '大概率彩铃（90%）' },
  { value: '11', label: '识别失败' },
  { value: '12', label: '识别失败' },
  { value: '21', label: '包含广告语，运营商铃声广告' },
  { value: '22', label: '音乐' },
  { value: '31', label: '关机' },
  { value: '32', label: '通话中（忙音）' },
  { value: '33', label: '无法接通' },
  { value: '34', label: '呼入限制' },
  { value: '35', label: '已设置来电提醒' },
  { value: '36', label: '呼叫转移' },
  { value: '91', label: '识别失败' },
  { value: '92', label: '识别失败' }
]

export const DICT_TYPE_POOL_SITUATION = [
  { value: '1', label: '短信' },
  { value: '2', label: '账单' },
  { value: '3', label: 'app列表' }
]

export const DICT_PAY_CHANNEL = [
  { value: 'alipay', label: '支付宝' },
  { value: 'wechat', label: '微信' },
  { value: 'offline', label: '线下支付' }
]

export const DICT_PAY_STATUS = [
  { value: '20', label: '已还款' },
  { value: '0', label: '未还款' },
  { value: '10', label: '还款中' }
]

export const DICT_BUSINESS_MAP = [
  { value: '1', label: '骑手车' },
  { value: '2', label: '租手机' },
  { value: '3', label: '手机品类' },
  { value: '4', label: '骑手站点租车' },
  { value: '5', label: '站点租机' },
  { value: '6', label: '手机回收' }
]

export const DICT_MDM_WATCH_STATUS = [
  { value: '0', label: '未监管' },
  { value: '1', label: '监管中' },
  { value: '2', label: '已锁定' }
]

export const DICT_MDM_NET_MODE = [
  { value: 'W', label: 'WIFI' },
  { value: 'D', label: 'Data' }
]

export const DICT_FINALJUDGE_SCORE_CARD = [
  { value: 3, label: '非常靠谱' },
  { value: 2, label: '靠谱' },
  { value: 1, label: '较靠谱' },
  { value: -2, label: '较不靠谱' },
  { value: -3, label: '不靠谱' },
  { value: -4, label: '极不靠谱' }
]

export const DICT_PHONE_REPEAT_TYPE = [
  { value: '1', label: '注册手机号' },
  { value: '2', label: '认证手机号' },
  { value: '3', label: '紧急联系人' },
  { value: '4', label: '通话记录' },
  { value: '5', label: '通讯录' }
]

export const DICT_ORDER_TYPE = [
  { value: '1', label: '轻松办单' },
  { value: '2', label: '普通办单' },
  { value: '3', label: '低质用户办单' },
  { value: '4', label: '极速办单' }
]

export const DICT_ELEMENT_TAG_STATUS = [
  { value: '1', label: '正常' },
  { value: '2', label: '搜到但异常' },
  { value: '3', label: '未搜到' },
  { value: '4', label: '账号冻结' }
]

export const DICT_REFUND_STATUS = [
  { value: '1', label: '待商家审核' },
  { value: '2', label: '商家已拒绝' },
  { value: '4', label: '商家已同意' }
]

export const DICT_SEARCH_REFUND_STATUS = [
  { value: '0', label: '未发生退款' },
  { value: '1', label: '待审核' },
  { value: '2', label: '审核拒绝' },
  { value: '3', label: '审核通过,待退款项' },
  { value: '4', label: '退款成功' },
  { value: '5', label: '退款失败' },
  { value: '6', label: '退款关闭' }
]

export const DICT_CREATE_ORDER_SOURCE = [
  { value: '1', label: '用户自己创建' },
  { value: '2', label: '营业员通过测算创建' },
  { value: '3', label: '后台通过测算创建' },
  { value: '4', label: '后台复制创建' }
]

export const DICT_MODEL_OLD_NEW = [
  { label: '99新', value: '99new' },
  { label: '95新', value: '95new' },
  { label: '9成新', value: '90new' },
  { label: '85新', value: '85new' },
  { label: '8成新', value: '80new' },
  { label: '7成新', value: '70new' },
  { label: '准新', value: 'quasiNew' },
  { label: '全新', value: '100new' }
]

export const DICT_RECYCLE_ORDER_STATUS = [
  { value: '5', label: '待认证' },
  { value: '15', label: '待审核' },
  { value: '90', label: '审核失败' },
  { value: '37', label: '驳回补充' },
  { value: '25', label: '待签约' },
  { value: '72', label: '待填退回地址' },
  { value: '10', label: '待寄出' },
  { value: '20', label: '待评估' },
  { value: '30', label: '待确认价格' },
  { value: '40', label: '待打款' },
  { value: '41', label: '待支付尾款' },
  { value: '50', label: '打款中' },
  { value: '60', label: '已完成' },
  { value: '70', label: '退回中' },
  { value: '95', label: '已退回' },
  { value: '91', label: '已取消' }
]

export const Dict_RECYCLE_FINENESS = [
  { value: '1', label: '全新未拆' },
  { value: '2', label: '高保充新' },
  { value: '3', label: '靓机' },
  { value: '4', label: '小花' },
  { value: '5', label: '大花' }
]

export const DICT_INFORMATION_BOOK_STATUS = [
  { value: '1', label: '未阅读告知书' },
  { value: '2', label: '已阅读告知书' },
  { value: '3', label: '比对失败' }
]

export const DICT_COMMISSION_TAG_PRICE = [
  { value: '1', label: '通用' },
  { value: '2', label: '零售价>结算价上限' },
  { value: '3', label: '零售价≤结算价上限' }
]

export const DICT_TRANSACTION_TYPES = [
  { value: '1', label: '用户还款' },
  { value: '2', label: '商户结算' },
  { value: '3', label: '商户支付技术服务费' },
  { value: '4', label: '商户退货款' },
  { value: '5', label: '退给商户技术服务费' },
  { value: '6', label: '用户退款退货' },
  { value: '7', label: '提前结清' },
  { value: '8', label: '手机退货退款' },
  { value: '9', label: '用户提现' }
]

export const DICT_ORDER_SETTLE_STATUS = [
  { value: '0', label: '不可结算' },
  { value: '1', label: '未打款' },
  { value: '2', label: '打款中' },
  { value: '3', label: '已打款' }
]

export const DICT_REPAYMENT_SETTLE_STATUS = [
  { value: '0', label: '未结算' },
  { value: '1', label: '结算中' },
  { value: '2', label: '结算成功' },
  { value: '3', label: '结算失败' },
  { value: '4', label: '结算失效' }
]

export const DICT_REPAYMENT_SETTLE_TYPES = [
  { value: '1', label: '货款' },
  { value: '2', label: '佣金' }
]

export const DICT_REPAYMENT_SETTLE_CHANNELS_ALL = [
  { value: '1', label: '支付宝API打款' },
  { value: '2', label: '自己提现' },
  { value: '3', label: '支付宝后台操作打款' },
  { value: '4', label: '二维码收款' },
  { value: '5', label: '回收打款' }
]

export const DICT_REPAYMENT_SETTLE_CHANNELS_SELECT = [
  { value: '1', label: '支付宝API打款' },
  { value: '2', label: '自己提现' },
  { value: '3', label: '支付宝后台操作打款' }
]

export const DICT_REPAYMENT_SETTLE_PAY_CHANNELS = [
  { value: 'wechat', label: '微信' },
  { value: 'alipay', label: '支付宝' },
  { value: 'bank', label: '银行卡' },
  { value: 'person', label: '个人' },
  { value: 'alipayX', label: '支付宝' }
]

export const DICT_BILL_STATUS = [
  { value: '0', label: '未还' },
  { value: '10', label: '还款中' },
  { value: '20', label: '已还' },
  { value: '30', label: '关闭' }
]

export const DICT_BILL_STATUS_HX = [
  { value: '0', label: '未到期' },
  { value: '1', label: '到期待付' },
  { value: '2', label: '已付' },
  { value: '3', label: '已退款' },
  { value: '4', label: '已买断' }
]

export const DICT_OTHER_REPAYMENT_PAY_TYPE = [
  { value: '11', label: '逾期费' },
  { value: '12', label: '下锁费' },
  { value: '13', label: '解锁费' }
]

export const DICT_WECHAT_PUSH_TYPE = [
  { value: '1', label: '文本' },
  { value: '2', label: 'markdown' },
  { value: '3', label: 'markdown_v2' },
  { value: '4', label: '图片' },
  { value: '5', label: '图文' },
  { value: '6', label: '文件' },
  { value: '7', label: '语音' },
  { value: '8', label: '模板卡片' }
]

export const DICT_RECYCLE_REPAYMENT_SETTLE_TYPES = [
  { value: '1', label: '预付款' },
  { value: '2', label: '佣金' },
  { value: '3', label: '尾款' }
]

export const DICT_FINAL_AUDIT_STATUS = [
  { value: '50', label: '同意' },
  { value: '90', label: '拒绝' },
  { value: '37', label: '驳回' }
]

export const DICT_RELATION_TYPE = [
  { value: '1', label: '父亲' },
  { value: '2', label: '母亲' },
  { value: '3', label: '配偶' },
  { value: '4', label: '同事' },
  { value: '5', label: '亲属' },
  { value: '6', label: '朋友' },
  { value: '7', label: '同学' }
]

export const DICT_MARRY_STATUS = [
  { value: '10', label: '未婚' },
  { value: '20', label: '已婚' },
  { value: '30', label: '丧偶' },
  { value: '40', label: '离异' }
]

export const DICT_MONTHLY_INCOME = [
  // { value: '1', label: '0-3000' },
  // { value: '2', label: '3000-5000' },
  // { value: '3', label: '5000-10000' },
  // { value: '4', label: '1万以上' },
  { value: '5', label: '3000' },
  { value: '6', label: '4000' },
  { value: '7', label: '5000' }
]

export const DICT_MARKUP_TYPE = [
  { value: '1', label: '固定值' },
  { value: '2', label: '按比例' }
]
